<template>
  <div class="map_con">
    <div class="map_header">
      <img alt="" src="../assets/image/map/logo.png">
      <div style="flex: 1;margin-left: 20px">
        <el-select v-model="cityId" class="el_select" @change="cityClick">
          <el-option v-for="(item,index) in cityList" :key="'city'+index" :label="item.name"
                     :value="item.id"></el-option>
        </el-select>
        <el-select v-model="areaId" class="el_select" @change="areaClick">
          <el-option :value="null" label="全部"></el-option>
          <el-option v-for="(item,index) in selectArea" :key="'area'+index" :label="item.name"
                     :value="item.id"></el-option>
        </el-select>
        <el-input v-model="keyword" placeholder="请输入关键字搜索" style="max-width: 257px" suffix-icon="el-icon-search"
                  @blur="getList"></el-input>

      </div>
      <el-button style="margin-right: 39px" type="primary" @click="goBack()">返回</el-button>
    </div>
    <baidu-map :center="{lng: 123.429096, lat: 41.796767}" :dragging="true"
               :map-click="false" :scroll-wheel-zoom="true"
               :zoom="zoom"
               class="map"
               @ready="handleReady">
      <!--          标注-->
      <bm-marker v-for="item in pointList" :key="item.longitude"
                 :icon="{url: require(`@/assets/image/map/map_${item.resourceType}.png`), size: { width: 74, height: 88 }}"
                 :position="{lng: item.longitude, lat: item.latitude}"
                 @click="(e) => { markerClick(e, item) }">
      </bm-marker>
      <bm-driving
          v-if="end"
          :auto-viewport="true"
          :end="end"
          :panel="false"
          :start="start"
      >
      </bm-driving>
      <bm-info-window ref="infoWindow" :position="currentPointItem" :show="infoWindowShow"
                      @close="infoWindowShow = false">
        <div class="info_window">
          <div class="info_title">{{ currentPointItem.resourceName }}</div>
          <img :src="fileUrl+currentPointItem.imageUrl" alt="" class="info_img">
          <div class="info_row">服务项目：{{ currentPointItem.serviceItems }}</div>
          <div class="info_row">开放时间：{{ currentPointItem.openStartTime + ' 至 ' + currentPointItem.openEndTime }}</div>
          <div class="info_row">详细地址：{{ currentPointItem.addressName }}</div>
          <el-button type="primary" @click="navigationClick(currentPointItem)">导航</el-button>
        </div>
      </bm-info-window>
    </baidu-map>

    <div class="display_flex bot_action">
      <div :class="{'sel_item': currentAction === item.id}" class="bot_item"
           @click="typeClick(item.id)" v-for="item in resourceTypes" :key="item.id">
        <img alt="" :src="require(`@/assets/image/map/icon_${item.img}.png`)">
        <div>{{ item.name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { FILE_API } from "@/Settings"

export default {
  name: "fitnessMap",
  data () {
    return {
      fileUrl: FILE_API,
      cityId: 1,
      areaId: 1,
      type: 1,
      keyword: '',

      resourceTypes: [
        { id: 1, name: '场馆', img: 'cg' },
        { id: 2, name: '步道', img: 'bd' },
        { id: 3, name: '室外场地', img: 'swcd' },
        { id: 4, name: '健身俱乐部', img: 'js' },
      ],
      currentAction: 1,

      BMap: null,
      map: null,
      zoom: 13, // 地图初始放大倍数
      pointList: [],
      currentPointItem: {},
      infoWindowShow: false,
      end: null,
      start: { lng: 123.463623, lat: 41.723834 },
      treeList: [],
      cityList: [],//市
      selectArea: []//区
    }
  },
  created () {
    this.getArea()
    this.geolocation()
  },
  methods: {
    /**
     * 浏览器定位函数
     */
    geolocation () {
      var that = this;
      var geolocation = new BMap.Geolocation();
      geolocation.getCurrentPosition(function(res) {
        if (this.getStatus() == BMAP_STATUS_SUCCESS) {
          that.start = res.point
        } else {
          console.log('failed' + this.getStatus()); //失败时，弹出失败状态码
        }
      }, { enableHighAccuracy: true }) //enableHighAccuracy：是否要求浏览器获取最佳效果，默认为false
    },
    typeClick (index) {
      this.currentAction = index
      this.end = null
      this.getList()
    },
    cityClick () {
      this.areaId = null
      let info = this.treeList.find(e => e.id === this.cityId)
      this.selectArea = info.children
      this.getList()
      this.map.centerAndZoom(info.name, this.zoom)
    },
    areaClick () {
      this.end = null
      this.getList()
    },
    // 省市区
    getArea () {
      this.$postAction('dict-area/tree').then((res) => {
        this.cityList = res.data[0].children
        this.treeList = res.data[0].children
        this.selectArea = this.cityList[0].children
        this.cityId = this.cityList[0].id
        this.areaId = null
        this.getList()
      })
    },
    getList () {
      this.$postAction('gateway/fitness-map/list', {
        "keyword": this.keyword,
        "resourceType": this.currentAction,
        "areaId": this.areaId,
        "cityId": this.cityId
      }).then((res) => {
        this.pointList = res.data
        // this.total = res.data.total
      })
    },
    handleReady ({ BMap, map }) {
      this.BMap = BMap
      this.map = map

      // BMAP_SATELLITE_MAP 卫星地图  BMAP_HYBRID_MAP 混合地图  BMAP_NORMAL_MAP 普通地图
    },

    markerClick (e, item) {
      this.$refs.infoWindow.observer.disconnect() //添加这个

      this.currentPointItem = { ...item, lng: Number(item.longitude), lat: Number(item.latitude) }
      this.infoWindowShow = true
    },
    navigationClick (item) {
      // 123.465109,41.746114
      this.end = { lng: item.lng, lat: item.lat }
    },
    goBack () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="less" scoped>
.map_con {
  height: 100vh;
  position: relative;

  .map_header {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    background: #ffffff;
    display: flex;
    align-items: center;

    .el_select {
      max-width: 160px;
      margin-right: 5%;
    }
  }

  .map {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
  }

  .info_window {
    .info_title {
      font-weight: 500;
      font-size: 20px;
    }

    .info_img {
      width: 298px;
      margin: 16px 0;
    }

    .info_row {
      font-size: 14px;
      margin-bottom: 14px;
    }
  }

  .bot_action {
    position: absolute;
    left: 50%;
    bottom: 26px;
    transform: translateX(-50%);
    width: 576px;
    background: #FFFFFF;
    border-radius: 4px;
    z-index: 2;
    padding: 15px 0;
    justify-content: space-around;

    .bot_item {
      height: 68px;
      padding: 0 16px;
      border-radius: 4px;
      font-size: 14px;
      color: #000000;
      text-align: center;
      cursor: pointer;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      img {
        margin-bottom: 9px;
      }
    }

    .sel_item {
      background: #0058a61a;
    }
  }
}

::v-deep .el-input__icon {
  cursor: pointer;
}
</style>
<style>
/*地图标题 infoWindow*/
.BMap_bubble_title {
  color: #fff;
  font-size: 18px;
  text-align: left;
  background: transparent !important;
}

.BMap_pop .BMap_top {
  background: #fff !important;
  border: 0 !important;
}

.BMap_pop .BMap_center {
  width: 251px !important;
  border: 0 !important;
  background: #fff !important;
}

.BMap_pop .BMap_bottom {
  border: 0 !important;
  background: #fff !important;
}

.BMap_pop div:nth-child(3) {
  background: transparent !important;
}

.BMap_pop div:nth-child(3) div {
  border-radius: 7px;
  background: #fff !important;
  border: 0 !important;
}

.BMap_pop div:nth-child(1) {
  border-radius: 7px 0 0 0;
  background: transparent !important;
  border: 0 !important;
}

.BMap_pop div:nth-child(1) div {
  background: #fff !important;
}

.BMap_pop div:nth-child(5) {
  border-radius: 0 0 0 7px;
  background: transparent !important;
  border: 0 !important;
}

.BMap_pop div:nth-child(5) div {
  border-radius: 7px;
  background: #fff !important;
}

.BMap_pop div:nth-child(7) {
  background: transparent !important;
}

.BMap_pop div:nth-child(7) div {
  border-radius: 7px;
  background: #fff !important;
}

.BMap_pop div:nth-child(8) div {
  /*border-radius:7px;*/
  background: #fff !important;
}

/*窗体阴影*/
.BMap_shadow div:nth-child(5) img {
  margin-left: -1100px !important;
}

.BMap_shadow div:nth-child(4) {
  width: 262px !important;
}

/*下面箭头替换为自己本地修改过的*/
/*img[src="http://api0.map.bdimg.com/images/iw3.png"] {*/
/*  content: url('../img/Screen/arrow.png');*/
/*}*/
/*img[src="https://api.map.baidu.com/images/iw3.png"] {*/
/*  margin-top: -692px !important;*/
/*  filter: alpha(opacity=70);*/
/*  content: url('../img/Screen/arrow.png');*/
/*}*/
</style>
